import { ComponentHeader, StyledCreate } from "@components";
import { useTranslation } from "react-i18next";
import { RedeemCdicForm } from "src/Modules/redeem/CdicForm";

export const PageRedeemCdicCoupon = () => {
  const { t } = useTranslation();
  return (
    <>
      <ComponentHeader title={t("page.redeem_cdic_coupon")} />
      <StyledCreate>
        <RedeemCdicForm />
      </StyledCreate>
    </>
  );
};
